import { useGitGraphQlQuery } from '@common/ExternalGitStatus/useExternalGitStatus';
import { gitInfoQuery } from '@common/queries/git';
import { GitQueryKeys } from '@common/queries/GitQueryKeys';

import { useGitQueryDefaultErrorHandler } from './useGitQueryDefaultErrorHandler';

export function useGitInfo(projectId: string) {
  const variables = { projectId };
  const onError = useGitQueryDefaultErrorHandler(projectId);
  return useGitGraphQlQuery(
    GitQueryKeys.Info,
    gitInfoQuery,
    {
      enabled: Boolean(projectId),
      onError: onError
    },
    variables
  );
}

export type GitInfoType = NonNullable<ReturnType<typeof useGitInfo>['data']>;
